/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, ProgressBar as ProgressBarCore, type ProgressBarProps as ProgressBarCoreProps, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';

interface SkeletonProps extends Omit<ProgressBarCoreProps, 'style' | 'className' | 'isIndeterminate' | 'formatOptions' | 'maxValue' | 'minValue' | 'value' | 'valueLabel'> {
  style?: stylex.StyleXStyles;
}

const SkeletonContext = createContext<ContextValue<SkeletonProps, HTMLDivElement>>({});

const Skeleton = forwardRef((props: SkeletonProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, SkeletonContext);

  const { style, ...coreProps } = props;

  return (
    <ProgressBarCore
      isIndeterminate
      ref={ref}
      aria-label="Loading"
      {...coreProps}
      {...stylex.props(styles.base, style)}
    />
  );
});

const pulsation = stylex.keyframes({
  '0%': { opacity: 1 },
  '50%': { opacity: 0.4 },
  '100%': { opacity: 1 },
});

const styles = stylex.create({
  base: {
    borderRadius: 2,
    animationDelay: '0.5s',
    animationDuration: '2s',
    animationIterationCount: 'infinite',
    animationName: pulsation,
    animationTimingFunction: 'ease-in-out',
    backgroundColor: $.surface03,
    height: 10,
    width: '100%',
  },
});

const SKELETON_MIN_DELAY_DURATION = 750;

export { SKELETON_MIN_DELAY_DURATION, Skeleton, SkeletonContext, type SkeletonProps };
